import React ,{useEffect,useState} from "react";
import { Card, CardBody, CardHeader, CardTitle, Col,Spinner, DropdownMenu, DropdownToggle, Nav, NavItem, NavLink, Row, TabContent, TabPane, UncontrolledDropdown } from 'reactstrap';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import { UpdateUserProfile } from '../actions/action';
import toast, { Toaster } from "react-hot-toast";
import classnames from "classnames"
import ProfileTab1 from './ProfileTab1';
import ProfileTab2 from './Profiletab2';
import defaultAvatar from '../../../assets/images/users/avatar-1.jpg';


const ProfileTab = () => {
    let  user_Img = ''
    let user_Name = ''
    let user_Email = ''
    const [activeTab, toggleTab] = useState("1");
    const [userName, setUserName] = useState("");
    const [userEmail, setUserEmail] = useState("");
    const [userImage, setUserImage] = useState("");
    if (localStorage.getItem("authUser")) {
        const userObj = JSON.parse(localStorage.getItem("authUser"));
        if (userObj?.role_id !== undefined) {
    
              user_Img = userObj?.image;
              user_Name= userObj?.user_name
              user_Email = userObj?.user_email
        }
      }
    const {userProfile = [], isProfileLoading} = useSelector(
        (state) => state.user
      );
      useEffect(() => {
        setUserName(userProfile?.data?.name);
        setUserEmail(userProfile?.data?.email)
        setUserImage(userProfile?.data?.image)
      }, [userProfile]);
      const userProfileDetail = userProfile?.data
     
    return (
        <React.Fragment>
            <Row>
                <Col xl={9} lg={8}>
                    <Card>
                        <CardBody>
                            <div className="d-flex align-items-center">
                                <div className="flex-shrink-0">
                                    <div className="avatar-xl me-3">
                                        <img
                                          src={userImage || user_Img || defaultAvatar}
                                          onError={(e) => {
                                            e.target.onerror = null;
                                            e.target.src = defaultAvatar;
                                          }}
                                          alt="profile"
                                          className="img-thumbnail rounded-circle h-100 w-100"
                                          style={{ objectFit: 'cover' }}
                                        />
                                    </div>
                                </div>
                                <div className="flex-grow-1">
                                    <h5 className="font-size-16 mb-1">{userName || user_Name}</h5>
                                    <p className="text-muted font-size-13 mb-0">{userEmail || user_Email}</p>
                                </div>
                            </div>

                            <Nav className="nav-tabs-custom card-header-tabs border-top mt-4 mx-0 mb-2 pt-3">
                                <NavItem>
                                    <NavLink
                                        to="#"
                                        className={classnames({
                                            active: activeTab === "1",
                                        }, "px-3")}
                                        onClick={() => {
                                            toggleTab("1")
                                        }}>
                                        Update Profile</NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        to="#"
                                        className={classnames({
                                            active: activeTab === "2",
                                        }, "px-3")}
                                        onClick={() => {
                                            toggleTab("2")
                                        }}
                                    >Change Password</NavLink>
                                </NavItem>
                               
                            </Nav>
                        </CardBody>
                    </Card>
                    <TabContent activeTab={activeTab}>
                        <TabPane tabId="1">
                            <ProfileTab1 />
                        </TabPane>
                        <TabPane tabId="2">
                            <ProfileTab2 />
                        </TabPane>
                      
                    </TabContent>
                </Col>
               
            </Row>
        </React.Fragment>
    );
}

export default ProfileTab;